

const ProjectCard = ({ project }) => {
  

  return (
    <div className="max-w-sm rounded overflow-hidden shadow-lg bg-white dark:bg-[#0b111b] p-4 rounded-xl">
      <div className="rounded-lg ">
       

            <img
              key={project.title}
              className="h-32 w-full rounded-lg"

              src={project.imageUrl}
              alt={`${project.title} - ${ + 1}`}
            />
     
       
      </div>
      <div className="px-2 py-4">
        <div className="font-bold text-xl mb-2">{project.title}</div>
        <p className="text-gray-800 dark:text-gray-200  text-xs">{project.description}</p>

      </div>
      <div className="px-2 py-4 flex justify-between text-xs">
        <a
          href={project.readLink}
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-500 hover:text-blue-700"
        >
          Read More
        </a>
      
      
      </div>
    </div>
  );
};
 const projectsss = [
    {
      title: 'MongoDB on Your Local Machine Using Docker',
      description:
        'In the ever-evolving landscape of database management, MongoDB stands tall as a reliable choice for developers. In this guide, we’ll explore the seamless integration of MongoDB...',
      techStack: 'MERN, WebSocket, AI APIs (Gemini), Redux',
      imageUrl: 'https://nileshblog.tech/wp-content/uploads/2024/01/image-1024x303.png?ezimgfmt=ng:webp/ngcb23',
     
      readLink: 'https://nileshblog.tech/mongodb-on-your-local-machine-using-docker/',
    },
    {
        title: 'My 30-Day Kubernetes Learning Plan',
        description:
          '30-Day Kubernetes Learning Plan Kubernetes is a powerful tool for container orchestration, and mastering it can be a game-changer for your career in DevOps or cloud-native development. ',
        techStack: 'MERN, WebSocket, AI APIs (Gemini), Redux',
        imageUrl: 'https://nileshblog.tech/wp-content/uploads/2024/12/Day-1_-Introduction-to-Kubernetes-and-the-30-Day-Learning-Plan.webp?ezimgfmt=ngcb23/notWebP',
       
        readLink: 'https://dev.to/speaklouder/my-30-day-kubernetes-learning-plan-3f0b',
      },
      {
        title: 'Ways to set Default values in Javascript 🎃🔰',
        description:
          'Discover the easiest Ways to set Default values in Javascript using the powerful or operator ,objects and other method. Boost your coding skills now! ',
        techStack: 'MERN, WebSocket, AI APIs (Gemini), Redux',
        imageUrl: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEjTA6RDY6vf9Qpd9pO2RqprHuDg3GeVxHcJzb8cU3vfeh-PIDjx6ni8mBAewIl-3akeX1mLDrhByPNyldyjJ742rp6ZcjGgY_B6i2SDNgvBf8yMdAr-f3bW1HvAkFyNHMoyyxByBBnVbewBKMyNXJGDqfLNMvso9TtTSIFTArlFsWNTpxjO3eX69henUh4/w640-h308-rw/carbon%20(1).png',
       
        readLink: 'https://www.technilesh.com/2023/10/ways-to-set-default-values-in-javascript.html',
      },
    

  ];
const Blog = () => {

  
 
  

  return (
    <div
    id="about"
    className="min-h-screen flex flex-col  items-center justify-center gap-16 px-6 lg:px-16 bg-[#edf2f8] dark:bg-gray-900 text-black dark:text-white  mb-4"
  >
    <h1 className='text-3xl font-bold mt-20 text-center'>My Recent <span className='text-red-500 '>BLOG</span> Posts <span className='text-red-500 '></span></h1>

    <div className='	'>

    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-16 max-w-[80vw] mx-auto">
  {projectsss.map((project, index) => (
    <ProjectCard key={index} project={project} />
  ))}
</div>




      {/* <div>1</div>
      <div>1</div>
      <div>1</div> */}
    </div>

</div>
  )
}

export default Blog;